var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-1/2 left-1/2 z-50 transform transition-transform -translate-x-1/2 -translate-y-1/2"},[_c('div',{staticClass:"lds-ring inline-block relative w-20 h-20"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])
}]

export { render, staticRenderFns }